import React from 'react'
import swal from 'sweetalert'

import database from '../config'

const remove = id => () => {
  swal({
    title: "Are you sure?",
    text: "You will not be able to recover this data!",
    icon: "warning",
    buttons: [
      'No, cancel it!',
      'Yes, I am sure!'
    ],
    dangerMode: true,
  }).then(function(isConfirm) {
    if (isConfirm) {
      database.ref('/' + id).set({})
    }
  })
}

const edit = (props, id) => {
  props.history.push(`/edit/${id}`)
}

const DataTableItem = (props) => {
  const { item } = props
  return (
    <tr>
      <td>{ item.url }</td>
      <td>{ item.email }</td>
      <td>{ item.password }</td>
      <td>{ item.createdAt }</td>
      <td>{ item.updatedAt }</td>        
      <td>    
        <button className="btn btn-ligth" title="Edit" data-toggle="tooltip" onClick={ () => edit(props, item.id) }>
          <i className="fas fa-edit"></i>
        </button>
        &nbsp;
        <button className="btn btn-ligth" title="Delete" data-toggle="tooltip" onClick={ remove(item.id) }>
            <i className="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  )
}

export default DataTableItem
